import { useMutation, useClient } from 'Data/Api.js'
import {
  notifyError,
  notifySuccess,
  useNotifications,
} from 'Logic/Notifications.js'
import { useSetFlowTo } from 'Simple/Flow.js'
import { email } from 'Data/validate.js'

import mutation from './mutation.graphql.js'

/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props) {
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value, change, originalValue }) {
    let isInvalid = !value.id || !email(value.email)

    if (isInvalid) {
      return true
    }

    let mutationResponse = await executeMutation({
      id: value.id,
      email: value.email,
    })

    if (mutationResponse.error) {
      notify(notifyError('Something went wrong. Please try again later.'))
      return
    }

    notify(notifySuccess('Email edited.'))
    change(originalValue)
  }
}
